import {useQuery} from "react-query";
import axios from "services/axios";

export function fetchStaffApiKeys(staffId) {
	return axios.get(`/staff/${staffId}/api-keys`).then(res => res.data);
}

export function useStaffApiKeys(staffId) {
	return useQuery({
		queryKey: ["staffApiKeys", staffId],
		queryFn: () => fetchStaffApiKeys(staffId),
		enabled: !!staffId,
		refetchOnWindowFocus: false,
	});
}
